exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".actions__btn{width:100%}.actions__btn--confirm{color:#4db6ac !important}", "", {"version":3,"sources":["/home/webuser/kmp3/releases/176/spa/src/pages/sales/actions/Actions.scss"],"names":[],"mappings":"AACE,cACE,UAAA,CAEA,uBACE,wBAAA,CAAA","file":"Actions.scss?vue&type=style&index=0&prod&lang=scss&external","sourcesContent":[".actions {\n  &__btn {\n    width: 100%;\n\n    &--confirm {\n      color: #4db6ac!important;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
